/**
 * @generated SignedSource<<39a86f49e6d4baffee2c9efab6fc4ab9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonTypeFilter_facility$data = {
  readonly lessonTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly defaultDurationMins: number;
        readonly id: string;
        readonly index: number;
        readonly name: string;
        readonly visibleToMembers: boolean | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"LessonTypeFilterOption_lessonType" | "lessonTypeHasRateForMembershipType_lessonType">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityLessonNoun_facility">;
  readonly " $fragmentType": "LessonTypeFilter_facility";
};
export type LessonTypeFilter_facility$key = {
  readonly " $data"?: LessonTypeFilter_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonTypeFilter_facility">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonTypeFilter_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityLessonNoun_facility"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LessonTypeConnection",
      "kind": "LinkedField",
      "name": "lessonTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LessonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LessonType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "index",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "visibleToMembers",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "defaultDurationMins",
                  "storageKey": null
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "lessonTypeHasRateForMembershipType_lessonType",
                  "selections": [
                    {
                      "alias": "lessonTypeRates",
                      "args": null,
                      "concreteType": "LessonRateConnection",
                      "kind": "LinkedField",
                      "name": "rates",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "LessonRateEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "LessonRate",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "allMembershipTypes",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ClientTypeConnection",
                                  "kind": "LinkedField",
                                  "name": "membershipTypes",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ClientTypeEdge",
                                      "kind": "LinkedField",
                                      "name": "edges",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": null,
                                          "kind": "LinkedField",
                                          "name": "node",
                                          "plural": false,
                                          "selections": [
                                            (v0/*: any*/)
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "LessonTypeFilterOption_lessonType"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};
})();

(node as any).hash = "a7a7518041eb2d521330067892e3df05";

export default node;
